import StorageDecorator from "./StorageDecorator";
import { IStorage } from "../IStorage";
import { IEncrypter } from "../../Encrypter/IEncrypter";

export default class StorageDecoratorEncrypter extends StorageDecorator {
  private _encrypter: IEncrypter;

  constructor(component: IStorage, encrypter: IEncrypter) {
    super(component);
    this._encrypter = encrypter;
  }

  public getItem(key: string): string {
    const ciphered = super.getItem(key);
    let decrypted = "";
    if (ciphered !== "") {
      decrypted = this._encrypter.decrypt(ciphered);
    }
    return decrypted;
  }

  public setItem(key: string, value: string) {
    const ciphered = this._encrypter.encrypt(value);
    super.setItem(key, ciphered);
  }
}
